<template>
  <div class="create-candidate-first">
    <portlet
            :icon="'fad fa-users'"
            :title="'Kandidaat toevoegen'"
            :actionsBlock="true"
    >
      <template slot="actionsBlock">
        <router-link tag="button" :to="{name:'candidates'}" class="btn btn-secondary">
          <i class="fas fa-long-arrow-left mr-2"></i> Terug
        </router-link>
      </template>

      <template slot="portletBody">
        <div class="row">
          <m-input
                  :col="'col-lg-4'"
                  :label="'Voornaam'"
                  :forId="'candidate-firstname'"
                  :required="'required'"
                  v-model="newCandidate.firstName"
          >
          </m-input>
          <m-input
                  :col="'col-lg-4'"
                  :label="'Achternaam'"
                  :forId="'candidate-lastname'"
                  :required="'required'"
                  v-model="newCandidate.lastName"
          >
          </m-input>
          <m-input
                  :col="'col-8 col-lg-3'"
                  :label="'Postcode'"
                  :forId="'candidate-zipcode'"
                  :required="'required'"
                  inputType="zipCode"
                  v-model="newCandidate.zipcode"
          >
          </m-input>
          <m-input
                  :col="'col-4 col-lg-1 rm-p-l'"
                  :label="'Nr.'"
                  :forId="'candidate-nr'"
                  :required="'required'"
                  v-model="newCandidate.housenumber"
          >
          </m-input>
        </div>
        <div class="row">
          <m-input
                  :col="'col-lg-4'"
                  :label="'Straatnaam'"
                  :forId="'candidate-street'"
                  :required="'required'"
                  v-model="newCandidate.street"
          >
          </m-input>
          <m-input
                  :col="'col-lg-4'"
                  :label="'Woonplaats'"
                  :forId="'candidate-residence'"
                  :required="'required'"
                  v-model="newCandidate.residence"
          >
          </m-input>
          <m-input
                  :col="'col-lg-4'"
                  :label="'Telefoonnummer'"
                  :forId="'candidate-telephone'"
                  :required="'required|phone'"
                  v-model="newCandidate.telephone"
          >
          </m-input>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-email">E-mailadres</label>
            <input name="E-mailadres"
                   id="candidate-email"
                   type="text"
                   class="form-control"
                   v-validate="'required|email'"
                   v-model="newCandidate.email">
            <span v-if="errors.first('E-mailadres')" class="small text-danger">{{errors.first('E-mailadres')}}</span>
          </div>
          <div class="form-group col-8 col-lg-3" :class="{'blacklisted': blacklisted}">
            <label for="candidate-birthdate">Geboortedatum</label>
            <input v-validate="'required'"
                   name="Geboortedatum"
                   id="candidate-birthdate"
                   type="date"
                   max="2999-12-30"
                   class="form-control placeholder-datel"
                   v-model="newCandidate.birthdate"
            >
            <span v-if="errors.first('Geboortedatum')" class="small text-danger">Geboortedatum moet in het volgende formaat zijn: dd-mm-jjjj</span>
          </div>
          <m-input-number
                  :col="'col-4 col-lg-1 rm-p-l'"
                  :label="'Leeftijd'"
                  :forId="'candidate-age'"
                  v-model.number="newCandidate.age"
                  :readonly="true"
                  :input-class="'form-control-plaintext'"
          >
          </m-input-number>
          <div class="col-lg-4">
            <label>Geslacht</label>
            <div class="form-group inline-radios gender-radio">
              <div class="custom-control custom-radio" v-for="gender in genders">
                <input :value="gender"
                       type="radio"
                       :id="gender"
                       name="gender"
                       class="custom-control-input"
                       v-validate="'required'"
                       v-model="newCandidate.gender"
                >
                <label class="custom-control-label" :for="gender">{{gender}}</label>
              </div>
              <span v-if="errors.first('gender')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-bsn">BSN</label>
            <input name="BSN"
                   id="candidate-bsn"
                   type="text"
                   maxlength="9"
                   class="form-control"
                   v-validate="'required|numeric|digits:9|bsn'"
                   v-model="newCandidate.bsn"
                   data-private>
            <span v-if="errors.firstByRule('BSN', 'bsn')" class="small text-danger">Dit BSN klopt niet (elfproef). Controleer het nummer.</span>
            <span v-else-if="errors.first('BSN')" class="small text-danger">Dit veld is verplicht en moet 9 cijfers bevatten.</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Wervingskanaal</label>
            <div class="form-group inline-radios">
              <div class="custom-control custom-radio" :key="'knownFroms-'+known" v-for="known in knownFroms">
                <input :value="known"
                       type="radio"
                       :id="known"
                       name="known"
                       class="custom-control-input"
                       v-validate="'required'"
                       v-model="newCandidate.knownFrom"
                >
                <label class="custom-control-label" :for="known">{{known}}</label>
              </div>
              <span v-if="errors.first('known')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row" v-if="newCandidate.knownFrom === 'Anders'">
          <div class="col-12">
            <v-select
                    taggable
                    v-model="newCandidate.knownFromOther"
                    :options="knownFromOthers"
                    :createOption="createOptionsKnownFrom"
                    class="form-group"
                    :selectOnTab="true"
                    v-validate="'required'"
                    name="knownFrom"
                    :class="{ 'is-invalid': errors.has('knownFrom') }"
            />
            <span v-if="errors.first('knownFrom')" class="small text-danger">Dit veld is verplicht.</span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Taal</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox" v-for="(language, index) in languages"
                   :key="language+'-'+index">
                <input v-model="newCandidate.language"
                       :value="language"
                       type="checkbox"
                       :id="language"
                       class="custom-control-input"
                       name="language"
                       v-validate="'required'"
                >
                <label class="custom-control-label" :for="language">{{language}}</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input v-model="newCandidate.language"
                       value="Anders"
                       type="checkbox"
                       id="language-other"
                       class="custom-control-input">
                <label class="custom-control-label" for="language-other">Anders</label>
              </div>
              <span v-if="errors.first('language')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
          <m-input
                  v-if="newCandidate.language.includes('Anders')"
                  :col="'col-sm-12 language-other'"
                  :forId="'candidate-language-others'"
                  name="language-other"
                  :label="'Taal anders'"
                  v-model="newCandidate.languageOther"
          >
          </m-input>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Ik wil werken in</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="(shift, index) in getStandardFormChoices('shifts')"
                   :key="'shift-'+index">
                <input v-model="newCandidate.shifts"
                       :value="shift"
                       type="checkbox"
                       :id="shift"
                       class="custom-control-input"
                       name="shifts"
                       v-validate="'required'"
                >
                <label class="custom-control-label" :for="shift">{{shift}}</label>
              </div>
              <span v-if="errors.first('shifts')" class="small text-danger">Dit veld is verplicht</span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Ik heb ervaring met</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="(experience,index) in getExperiences"
                   :key="'experience-'+index">
                <input v-model="newCandidate.experiences"
                       :value="experience.name"
                       type="checkbox"
                       :id="experience.id"
                       class="custom-control-input"
                       name="experiences-name"
                       v-validate="'required'"
                >
                <label class="custom-control-label"
                       :for="experience.id">{{experience.name}}</label>
              </div>
              <div class="custom-control custom-checkbox">
                <input v-model="newCandidate.experiences"
                       value="Anders"
                       type="checkbox"
                       id="experience-other"
                       class="custom-control-input">
                <label class="custom-control-label" for="experience-other">Anders</label>
              </div>
              <span v-if="errors.first('experiences-name')" class="small text-danger">Dit veld is verplicht</span>
            </div>
            <v-select v-if="newCandidate.experiences.includes('Anders')"
                      taggable
                      multiple
                      :options="getOtherExperiences"
                      label="name"
                      @option:created="addExperienceValue"
                      v-model="newCandidate.experienceOther"
                      class="form-group taggable-select"
                      :selectOnTab="true"
            >
              <div slot="no-options">Voeg een andere ervaring toe.</div>
            </v-select>
          </div>
        </div>
      </template>
    </portlet>

    <portlet
            :icon="'fad fa-file-certificate'"
            :title="'Ik heb de volgende certificaten in bezit'"
            :footer="true"
    >
      <template slot="portletBody">
        <div class="row m-hide-lg">
          <div class="col">
            <label>Certificaat</label>
          </div>
          <div class="col">
            <label>Behaald bij</label>
          </div>
          <div class="col">
            <label>Geldig tot</label>
          </div>
          <div class="col last-repeat-col"></div>
        </div>
        <select-certificate
                v-for="(certificate,index) in newCandidate.certificates"
                :key="index"
                :renderedComponent="renderedComponent"
                :certificates="getCertificates"
                :certificate="certificate"
                :certificateIndex="index"
                @certificateRemoved="removeCertificateRow($event)"
        />
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addCertificateRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
            :icon="'fad fa-user-graduate'"
            :title="'Ik heb de volgende opleidingen afgerond'"
            :footer="true"
    >
      <template slot="portletBody">
        <div class="row m-hide-lg">
          <div class="col">
            <label>Opleiding</label>
          </div>
          <div class="col">
            <label>Niveau</label>
          </div>
          <div class="col last-repeat-col"></div>
        </div>
        <select-education
                v-for="(education,index) in newCandidate.educations"
                :key="education+'-'+index"
                :renderedComponent="renderedComponent"
                :educations="getEducations"
                :education="education"
                :educationIndex="index"
                @addEducation="newEducation($event)"
                @educationRemoved="removeEducationRow($event)"
        />
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addEducationRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"></i> Toevoegen
        </button>
      </div>
    </portlet>

    <portlet
            :icon="'fad fa-file-user'"
            :title="'Dit waren mijn laatste functies'"
            :footer="true"
    >
      <div slot="portletBody">
        <latest-functions
                v-for="(position,index) in newCandidate.positions"
                :key="position+'-'+index"
                :positionIndex="index"
                :positions="position"
                :renderedComponent="renderedComponent"
                @positionRemoved="removePositionRow($event)"
        />
      </div>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="addPositionRow()" type="submit" class="btn btn-secondary">
          <i class="fa fa-plus mr-2"/> Toevoegen
        </button>
      </div>
    </portlet>


    <portlet
        :icon="'fad fa-user-clock'"
        :title="'Poules'"
        :footer="false"
    >
      <div slot="portletBody">
        Voeg de gebruiker toe aan onderstaande poules:<br>
        <i>Het is verplicht om minimaal één poule te kiezen</i>

        <div class="pool-selector">
          <selectMultiplePools :is-invalid="!this.newCandidate.poolChanges.added.length && showInvalidPools" @poolsChanged="poolsChanged" :candidate-id="this.newCandidate.id"></selectMultiplePools>
        </div>
      </div>
    </portlet>

    <portlet
            :icon="'fad fa-info-circle'"
            :title="'Overige informatie'"
            :footer="true"
    >
      <template slot="portletBody">
        <div class="row">
          <div class="col-12">
            <label>Ik ben in het bezit van</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"
                   v-for="transport in getStandardFormChoices('transports')">
                <input v-model="newCandidate.transports"
                       :value="transport"
                       type="checkbox"
                       :id="transport"
                       class="custom-control-input">
                <label class="custom-control-label" :for="transport">{{transport}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <label>Rijbewijzen</label>
            <div class="form-group inline-checkboxes">
              <div class="custom-control custom-checkbox"  :key="license"  v-for="license in getStandardFormChoices('drivingLicenses')">
                <input v-model="newCandidate.drivingLicenses"
                       :value="license"
                       type="checkbox"
                       :id="license"
                       class="custom-control-input">
                <label class="custom-control-label" :for="license">{{ license }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-lg-4">
            <label for="candidate-max-travel">Maximale reisafstand (KM)</label>
            <input v-validate="'required'"
                   name="candidate-max-travel"
                   id="candidate-max-travel"
                   type="number"
                   class="form-control"
                   v-model="newCandidate.travelDistance">
            <span v-if="errors.first('candidate-max-travel')" class="small text-danger">Dit veld is verplicht.</span>
          </div>
          <div class="form-group col-lg-4 salary-input">
            <label for="candidate-salaryMin">Bruto salarisindicatie in euro's (per/uur)</label>
            <div class="row no-gutters">
              <div class="col-6">
                <input v-validate="'required'"
                       name="candidate-salaryMin"
                       id="candidate-salaryMin"
                       type="number"
                       class="form-control width-half"
                       v-model="newCandidate.salaryMin"
                       placeholder="Minimaal"
                >
                <span v-if="errors.first('candidate-salaryMin')" class="small text-danger">Dit veld is verplicht.</span>
              </div>
<!--              <div class="col-6">-->
<!--                <input v-validate="'required'"-->
<!--                       name="candidate-salaryMax"-->
<!--                       id="candidate-salaryMax"-->
<!--                       type="number"-->
<!--                       class="form-control width-half"-->
<!--                       v-model="newCandidate.salaryMax"-->
<!--                       placeholder="Maximaal"-->
<!--                >-->
<!--                <span v-if="errors.first('candidate-salaryMax')" class="small text-danger">Dit veld is verplicht.</span>-->
<!--              </div>-->
            </div>
          </div>
          <div class="form-group col-lg-4">
            <label for="candidate-availableDate">Beschikbaar per</label>
            <datepicker
                    name="candidate-availableDate"
                    :language="nl"
                    id="candidate-availableDate"
                    v-model="newCandidate.availableDate"
                    :fullMonthName="true"
                    format="dd-MM-yyyy"
                    input-class='form-control'
                    :calendar-button="true"
                    :calendar-button-icon="'far fa-calendar-alt'"
                    :clear-button="true"
                    :clear-button-icon="'far fa-times'"
                    :disabledDates="disabledDates"
                    :class="{ 'is-invalid': errors.has('availableDate') }"
            >
            </datepicker>
            <input v-model="newCandidate.availableDate" v-show="false" v-validate="'required'"
                   name="availableDate"/>
          </div>
        </div>
      </template>
      <div slot="portletFooter" class="col-12 text-right">
        <button @click="goToNextPage()" type="submit"
                class="btn btn-primary">Volgende
          <i class="fa fa-long-arrow-right ml-2"></i>
        </button>
      </div>
    </portlet>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';
  import mInput from '../../components/forms/mInput';
  import mInputNumber from '../../components/forms/mInputNumber';
  import SelectCertificate from './selectCertificate';
  import SelectEducation from './selectEducation';
  import LatestFunctions from './latestPositions';
  import Datepicker from 'vuejs-datepicker';
  import {nl} from 'vuejs-datepicker/dist/locale';
  import {candidateData} from '../mixins/candidateData';
  import {candidateMethods} from '../mixins/candidateMethods';
   import {getPostalData} from '../mixins/getPostalData';


  export default {
    mixins: [candidateData, candidateMethods,getPostalData],
    components: {
      mInput,
      mInputNumber,
      SelectEducation,
      SelectCertificate,
      LatestFunctions,
      Datepicker
    },
    props: ['blankModus', 'candidate'],
    provide() {
      return {
        $validator: this.$validator
      };
    },
    data() {
      return {
        tempImage: '',
        blacklisted: false,
        nl: nl,
        renderedComponent: true,
        disableNavigation: false,
        candidateCopy: null,
        newCandidate: {
          poolChanges: {
            added: [],
            removed: []
          },
          firstName: '',
          lastName: '',
          zipcode: '',
          housenumber: '',
          street: '',
          residence: '',
          telephone: '',
          email: '',
          bsn: '',
          birthdate: '',
          age: null,
          gender: '',
          knownFrom: '',
          knownFromOther: '',
          language: [],
          languageOther: '',
          shifts: [],
          experiences: [],
          experienceOther: [],
          certificates: [{
            name: null,
            achievedAt: null,
            validUntil: null
          }],
          educations: [{
            name: null,
            level: null
          }],
          positions: [{
            name: null,
            employer: null,
            startDate: null,
            endDate: null,
            activities: null,
            reasonLeft: null
          },
            {
              name: null,
              employer: null,
              startDate: null,
              endDate: null,
              activities: null,
              reasonLeft: null
            }],
          travelDistance: null,
          availableDate: null,
          transports: [],
          retirements: [],
          sick: false,
          drivingLicenses:  [],
          geoLocation: {lat: null, lng: null}
        },
        showInvalidPools: false,
      };
    },
    methods: {
      editExistingCandidate(candidate) {
        let id = candidate.id;
        this.$emit('unsavedChanges', false);
        this.$swal({
          title: 'Kandidaat bestaat al',
          text: 'Wil je deze kandidaat bewerken?',
          type: 'info',
          confirmButtonText: 'Ja, bewerken',
          showCancelButton: true,
          cancelButtonText: 'Annuleren',
          reverseButtons: true
        }).then((result) => {
          if(result.value) {
            this.$router.push('/candidates/' + id);
          }
        });
      },
      blankExistingCandidate() {
        this.$swal({
          title: 'Kandidaat bestaat al',
          text: 'De ingevulde voornaam + achternaam zijn al bekend in het systeem.',
          type: 'info',
          confirmButtonText: 'Sluiten'
        });
      },
      poolsChanged(pools) {
        this.candidate.poolChanges = pools;
      },
      goToNextPage() {
        this.$validator.validateAll().then((result) => {
          var validationArrayChild = this.$children.map(function (child) {
            return child.$validator.validateAll();
          });
          window.Promise.all(validationArrayChild).then((v) => {
            const poolValid = this.newCandidate.poolChanges.added.length > 0;
            this.showInvalidPools = !poolValid;

            let validCheck = _.includes(v, false);
            if(result && !validCheck && poolValid) {
              this.$emit('switchPage', 'candidateInformationAdditional');
            } else {
              this.$toasted.global.failedFormRequest();
            }
          }).catch((err) => {
            console.log(err);
          });
        }).catch((err) => {
          console.log(err);
          this.$toasted.global.failedFormRequest();
        });
      },
      autoFillBasedOnPostal(candidate) {
        let rege = /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i;
        candidate = this.newCandidate
        if(candidate.zipcode && candidate.housenumber) {
          if(rege.test(candidate.zipcode)) {
            this.$store.commit('setLoading', true);
            this.getPostalData(candidate.zipcode,candidate.housenumber).then(res => {
              if(res.status == 200) {
                let data = res.data;
                this.newCandidate.residence = data.city;
                this.newCandidate.street = data.street;
              }
            }).catch(e => {
              this.$store.commit('setLoading', false);
              console.error(e);
            }).finally(() => {
              this.$store.commit('setLoading', false);
            });
          }
        }
      }
    },
    computed: {
      ...mapGetters('candidates', [
        'getStandardFormChoices',
        'checkCandidate'
      ]),
      ...mapGetters('blacklist',
          ['checkBlacklist']),
      ...mapGetters('certificates',
          ['getCertificates']),
      ...mapGetters('experiences', [
            'getExperiences',
            'getOtherExperiences'
          ]
      ),
      ...mapGetters('educations',
          ['getEducations']),

      getFullName() {
        return this.newCandidate.firstName + ' ' + this.newCandidate.lastName;
      },
      blackListCheck() {
        return this.newCandidate.lastName + ' ' + this.newCandidate.birthdate;
      }
    },
    watch: {
      newCandidate: {
        handler: function (newV, oldV) {
          if(newV !== oldV) {
            this.$emit('candidateUpdated', newV);
          }
          this.$emit('unsavedChanges', JSON.stringify(newV) !== JSON.stringify(this.candidateCopy));
        },
        deep: true
      },
      getFullName(fullname) {
        if(fullname) {
          let existingCandidate = this.checkCandidate(this.newCandidate.firstName, this.newCandidate.lastName);
          if(existingCandidate && !this.blankModus) {
            this.editExistingCandidate(existingCandidate);
          } else if(existingCandidate && this.blankModus) {
            this.blankExistingCandidate();
          }
        }
      },
      blackListCheck(check) {
        if(check) {
          let blackListCandidate = this.checkBlacklist(this.newCandidate.lastName, this.newCandidate.birthdate);
          this.blacklisted = !!blackListCandidate;
        }
      },
      'newCandidate.birthdate': function (val) {
        this.newCandidate.age = Math.floor(moment.duration(moment().diff(val)).asYears());
      },
      'newCandidate.zipcode': function (val, oldV) {
         if(val && this.newCandidate.housenumber)
          this.autoFillBasedOnPostal(val);
      },
      'newCandidate.housenumber': function (val, oldV) {
        if(val && this.newCandidate.zipcode)
          this.autoFillBasedOnPostal(val);
      }
    },
    created() {
      this.newCandidate = this.candidate;
      this.candidateCopy = JSON.parse(JSON.stringify(this.candidate));
    }

  };
</script>
<style lang="scss" scoped>
.pool-selector {
  margin-top: 12px;
}
</style>